import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Axios from "axios";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import { DeactivateQuestions, GetInterviewQuestions, GetJobRoles, GetTestTypes } from "../apiconstants/constants";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import {Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";
import Select from "react-select";
import { useCountry } from "../contexts/countrycodecontext.js";
const ViewInterviewQuestions = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [jobRoles, setJobRoles] = useState([]);
    const [testTypes, setTestTypes] = useState([]);
    const [selectedJobRole, setSelectedJobRole] = useState("");
    const [selectedTestType, setSelectedTestType] = useState("");
    const [filteredQuestions, setFilteredQuestions] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(25);
    const [showModal,setShowModal] = useState(false)
    const [questionId, setQuestionId] = useState(null);
    const [userGuid,setUserGuid] = useState("");
    const [showIcon, setShowIcon] = useState('list');
    const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
    let Guid="";
const {selectedCountry} = useCountry();
const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")
const token = localStorage.getItem("jwtToken");
const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}
    const fetchQuestions = async () => {
        setIsLoading(true);
        try {
           const response = await Axios.get(
  `${GetInterviewQuestions.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

            setQuestions(response.data);
            setFilteredQuestions(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching questions", error);
            setIsLoading(false);
        }
    };

    const fetchJobRoles = async () => {
        try {
            const response = await Axios.get(`${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`);
            setJobRoles(response.data);
        } catch (error) {
            console.error("Error fetching job roles", error);
        }
    };

    const fetchTestTypes = async () => {
        try {
            const response = await Axios.get(GetTestTypes.APIURL,{headers: { Authorization: `Bearer ${token}` } });
            setTestTypes(response.data);
        } catch (error) {
            console.error("Error fetching test types", error);
        }
    };
    const handleConfirmDeactivation = async () => {
       await Axios.put(
  `${DeactivateQuestions.APIURL}?employerguid=${userGuid}&Qguid=${questionId}&type=0`,
  {}, // empty body
  {
    headers: { Authorization: `Bearer ${token}` }
  }
)

          .then((result) => 
            {
              if(result.data.message=='Question Deactivated successfully.'){
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'DeActivated succesfully',
                  showConfirmButton: false,
                  timer: 2000,
                })
              }
            //  setQuestions(prevData => prevData.filter(question => question.qGuid != questionId));
              fetchQuestions();
            setIsLoading(false);
            setShowModal(false);
    
          })
          .catch((error) => {
            console.log("Error" + error);
          });
        }
    
  const handleViewToggle = (type) => {
  setViewType(type);
  setShowIcon(type)
};
    
    const handleCancel = () => {
      setShowModal(false);
    };
    const handleDeactivateQuestion = (qGuid,userGuid) => {
        setQuestionId(qGuid);
        setUserGuid(userGuid)
        setShowModal(true)
      };
    useEffect(() => {
        fetchQuestions();
        fetchJobRoles();
        fetchTestTypes();
    }, [selectedCountry]);

    const getJobRole = (id) => {
        const role = jobRoles.find(role => role.jobRoleId == id);
        return role ? role.jobRole : 'Unknown';
    };

    const getTestType = (id) => {
        const type = testTypes.find(type => type.testTypeID == id);
        return type ? type.testType : 'Unknown';
    };

    const handleSearch = () => {
      const filtered = questions.filter((question) => {
          return (
              (!selectedJobRole || question.jobRoleID === selectedJobRole) &&
              (!selectedTestType || question.testTypeID === selectedTestType)
          );
      });
      setFilteredQuestions(filtered);
      setCurrentPage(0);
  };

  const jobRoleOptions = jobRoles.map(role => ({
      value: role.jobRoleId,
      label: role.jobRole
  }));

  const testTypeOptions = testTypes.map(type => ({
      value: type.testTypeID,
      label: type.testType
  }));

  const handleJobRoleChange = (selectedOption) => {
      setSelectedJobRole(selectedOption ? selectedOption.value : null);
  };

  const handleTestTypeChange = (selectedOption) => {
      setSelectedTestType(selectedOption ? selectedOption.value : null);
  };
  

    // Pagination logic
    const offset = currentPage * itemsPerPage;
    const currentItems = filteredQuestions.slice(offset, offset + itemsPerPage);

    const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    };

    return (
        <ConsultantLayout>
            <section>
                {isLoading ? (
                    <center><LoadingSpinner /></center>
                ) : (
                    <div className="container-fluid mt-4 pb-5">

<div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
        <div>                                <h2 className="" style={{ color: "#00a7ac" }}>List of Questions</h2>
</div>
<div
  style={{
    display: 'flex',  
    justifyContent: 'space-between',
   gap:10
  }}
>
  {/* Job Role Dropdown */}
  <div style={{ flex: '1 1 300px', maxWidth: '100%' }}>
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>
      )}
    >
      <Select
        options={jobRoleOptions}
        value={jobRoleOptions.find(option => option.value === selectedJobRole)}
        onChange={handleJobRoleChange}
        placeholder="Select Job Role"
        styles={{
          control: (provided) => ({
            ...provided,
            fontSize: '14px', // Change this to your desired size
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
        }}
      />
    </OverlayTrigger>
  </div>

  {/* Test Type Dropdown */}
  <div style={{ flex: '1 1 320px', maxWidth: '100%' }}>
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Select Test Type</Tooltip>
      )}
    >
      <Select
        options={testTypeOptions}
        value={testTypeOptions.find(option => option.value === selectedTestType)}
        onChange={handleTestTypeChange}
        placeholder="Select Test Type"
        styles={{
          control: (provided) => ({
            ...provided,
            fontSize: '14px', // Change this to your desired size
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '14px',
          }),
        }}
      />
    </OverlayTrigger>
  </div>

  {/* Search Button */}
  <div>
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Search</Tooltip>
      )}
    >
      <Link>
        <button className="btn btn-primary" type="button" onClick={handleSearch}>
          <i className="fa fa-search" />
        </button>
      </Link>
    </OverlayTrigger>
  </div>

  {/* Toggle Grid/List View */}
  <div>
    {showIcon === 'grid' ? (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
        <button
          className="btn btn-primary"
          onClick={() => handleViewToggle('list')}
          style={{
            backgroundColor: "#00a7ac",
            height: "38px",
            width: "38px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i className="fa fa-th-list" style={{ color: '#fff', fontSize: "16px" }} />
        </button>
      </OverlayTrigger>
    ) : (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
        <button
          className="btn btn-primary"
          onClick={() => handleViewToggle('grid')}
          style={{
            backgroundColor: "#00a7ac",
            height: "38px",
            width: "38px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i className="fa fa-th" style={{ color: '#fff', fontSize: "16px" }} />
        </button>
      </OverlayTrigger>
    )}
  </div>

  {/* Add Question Button */}
  <div>
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Add Questions</Tooltip>
      )}
    >
      <Link to="/Employer/AddQuestions">
        <button className="btn btn-primary" type="button">
          <i className="fa fa-plus" />
        </button>
      </Link>
    </OverlayTrigger>
  </div>
</div>

        </div>
        <hr/>
        {viewType === 'grid' ? (
                        <div className="row mt-5">
                            {currentItems.map((item) => (
                                <div key={item.qGuid} className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3">
                                    <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', borderRadius: 20 }}>
                                        <div className='card-body'>
                                            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                                                <p style={{ fontSize: 14 }}><strong>Job Role:</strong> {getJobRole(item.jobRoleID)}</p>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Test Type</Tooltip>)}>
                                                <p style={{ fontSize: 14 }}><strong>Test Type:</strong> {getTestType(item.testTypeID)}</p>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Question</Tooltip>)}>
                                                <p style={{ fontSize: 14, height:'270px'}}><strong>Question:</strong> {parse(DOMPurify.sanitize(item.question))}</p>
                                            </OverlayTrigger>
                                           </div> 
                                            <div className='card-footer d-flex justify-content-between'>
                                                <Link to={`/Employer/EditQuestions/${item.qGuid}`}>
                                                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                                                        <button style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </Link>
                                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Deactivate Question</Tooltip>)}>
                                                        <button onClick={() => handleDeactivateQuestion(item.qGuid,item.userGuid)} style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-trash" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                
                                            </div>
                                        
                                    </div>
                                </div>
                            ))}
                        </div>
        ):
     ( <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                              <table className="table" 
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    tableLayout: "fixed",
    wordWrap: "break-word",}}>
        <thead>
          <tr>
            <th>Job Role</th>
            <th>Test Type</th>
            <th>Question</th>
            <th>Actions</th>
            </tr>
        </thead>
        <tbody>
          {currentItems?.map((item, index) => (
            <tr key={index}>
              <td>{getJobRole(item.jobRoleID)}</td>
              <td>{getTestType(item.testTypeID)}</td>
              <td>  {parse(DOMPurify.sanitize(item.question))}</td>
              <td> <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
              <Link to={`/Employer/EditQuestions/${item.qGuid}`}>
                                                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                                                        <button style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                                </Link>
                                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Deactivate Question</Tooltip>)}>
                                                        <button onClick={() => handleDeactivateQuestion(item.qGuid,item.userGuid)} style={{ background: "none", border: "none" }}>
                                                            <i className="fa fa-trash" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i>
                                                        </button>
                                                    </OverlayTrigger>
                                            </div>
                                            </td>
             </tr>
          ) )}
        </tbody>
      </table>
    </div>
      )}
                        {filteredQuestions.length === 0 && (
          <div className="pb-5 text-center">
            <img title='No Data' alt='no-data-img' className='no-data-img' src={nodataimg} style={{ height: 370 }} />
          </div>
        )}
                        {filteredQuestions.length > itemsPerPage && (
                        <ReactPaginate
                            previousLabel={"Prev"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={Math.ceil(filteredQuestions.length / itemsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            disabledClassName={"disable-pagination-button"}
                        />
                        )}
                        
<Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this question?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation}>Yes</Button>
        </Modal.Footer>
      </Modal>
                    </div>
                )}
            </section>
        </ConsultantLayout>
    );
}

export default ViewInterviewQuestions;

